import React, { Component } from 'react';
import { ApolloConsumer } from 'react-apollo';
import RequestAccess from './RequestAccess';
import { mapRequests } from '../utils';












export default class RequestProvider extends Component {
  constructor() {
    super();

    this.state = {
      resourceOwnerId: void 0
    };
  }

  promptRequestAccess = ({ resourceOwnerId }) => {
    this.setState({ resourceOwnerId });
  };

  render() {
    const { children, requests } = this.props;
    const { resourceOwnerId } = this.state;

    return (
      <ApolloConsumer>
        {(client) => {
          if (resourceOwnerId) {
            return <RequestAccess apiClient={client} ownerId={resourceOwnerId} />;
          }

          return (
            children(mapRequests(
              client,
              requests,
              this.promptRequestAccess
            )));

        }}
      </ApolloConsumer>);


  }
}